import React, { PureComponent } from "react";
import { withActions } from "actionware";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";

import LoanTable from "./loanTable";
import LenderSelector from "./lenderSelection";
import LoanSummary from "./summary";
import {
  getApplication,
  resetApplication,
} from "../application/applicationApprovalActions";
import { getRole, getLenderId } from "../../common/helpers";
import { fetchLenderPortfolioV2 } from "../approval/summaryActions";
import { getLendersList } from "../fundingLimit/fundingLimitActions";
import { Spin } from "antd";
import { isLenderPortfolioApiEnabled } from "../../common/config";

@connect(
  ({
    localize,
    funding: { lenders },
    summary: { portfolioSummary },
    applicationApproval: { applications },
    lenderStatistic: { summary },
  }) => ({
    translate: getTranslate(localize),
    lenders,
    applications,
    summary,
    portfolioSummary,
  })
)
@withActions({
  getApplication,
  resetApplication,
  getLendersList,
  fetchLenderPortfolioV2,
})
class Loan extends PureComponent {
  constructor() {
    super();
    this.state = {
      role: "",
      currentLenderId: null,
      fetchingLenderDetails: false,
    };
    this.handleFetchApplications = this.handleFetchApplications.bind(this);
    this.setCurrentLender = this.setCurrentLender.bind(this);
  }
  async componentWillMount() {
    const {
      getApplication,
      resetApplication,
      getLendersList,
      fetchLenderPortfolioV2,
    } = this.props;
    resetApplication();

    const role = await getRole();
    const lenderId = await getLenderId();
    let params = {};

    this.setState({
      role,
      fetchingLenderDetails: true,
    });

    if (["LENDER"].includes(role)) {
      this.setState({
        currentLenderId: lenderId,
      });
      const applicationRequest = getApplication({
        sort_field: "submission_date",
        sort_order: "desc",
        status: "approved",
        page: 1,
        size: 10,
        lender_id: lenderId,
      });
      if (!isLenderPortfolioApiEnabled()) {
        applicationRequest.then(this.toggleLoaderState);
      }
    }
    if (["FINANCE", "ADMIN"].includes(role)) {
      getLendersList();
      params = {
        lender_id: lenderId,
      };
    }

    if (isLenderPortfolioApiEnabled()) {
      fetchLenderPortfolioV2(params).then(this.toggleLoaderState);
    } else if (["FINANCE", "ADMIN"].includes(role)) {
      this.toggleLoaderState();
    }
  }

  toggleLoaderState = () => {
    this.setState({
      fetchingLenderDetails: false,
    });
  };

  handleFetchApplications(params) {
    const { getApplication, fetchLenderPortfolioV2 } = this.props;
    this.setState({
      fetchingLenderDetails: true,
    });
    if (isLenderPortfolioApiEnabled()) {
      fetchLenderPortfolioV2({ lender_id: params.lender_id });
    }
    getApplication(params).then(() => {
      this.toggleLoaderState();
    });
  }

  setCurrentLender(val) {
    this.setState({ currentLenderId: val });
  }

  renderLenderPortfolioAndApplication() {
    const { translate, applications, portfolioSummary } = this.props;
    const { role, currentLenderId, fetchingLenderDetails } = this.state;
    if (
      fetchingLenderDetails ||
      (isLenderPortfolioApiEnabled() && Object.keys(portfolioSummary).length === 0)
    ) {
      return <Spin tip={translate("generic.loadingData")} size="large" />;
    }
    return (
      <>
        {isLenderPortfolioApiEnabled() && (
          <LoanSummary summary={portfolioSummary} />
        )}
        {Object.keys(applications).length > 0 && (
          <LoanTable
            applications={applications}
            currentLenderId={currentLenderId}
            role={role}
          />
        )}
      </>
    );
  }

  render() {
    const { translate, lenders } = this.props;
    const { role, fetchingLenderDetails } = this.state;
    return (
      <div>
        {role && ["ADMIN", "FINANCE"].includes(role) && (
          <LenderSelector
            translate={translate}
            lenders={lenders}
            fetchingLenderDetails={fetchingLenderDetails}
            fetchApplication={this.handleFetchApplications}
            setCurrentLender={this.setCurrentLender}
          />
        )}
        {this.renderLenderPortfolioAndApplication()}
      </div>
    );
  }
}

export default Loan;
